export default "__VITE_ASSET__8629471a__"